<template>
    <framed-content :title="formTitle">
        <div :class="{'grid-display': true, [columnsClass]: true}">
            <slot/>
        </div>
    </framed-content>
</template>

<script>
    import FramedContent from "../layout/FramedContent";
    export default {
        name: "FormWrapper",
        components: {FramedContent},
        props: {
            columns: {
                type: Number,
                default: 1
            },
            formTitle: String
        },
        computed: {
            columnsClass() {
                return 'columns' + this.columns;
            }
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
.grid-display {
    display: grid;
    grid-gap: 10px;
    grid-column-gap: 10px;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
}

.columns1 {
    grid-template-columns: minmax(100px, auto) 1fr;
}

.columns2 {
    grid-template-columns: minmax(100px, auto) 1fr minmax(100px, auto) 1fr;
}

.columns3 {
    grid-template-columns: minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr;
}

.columns4 {
    grid-template-columns: minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr;
}

.columns5 {
    grid-template-columns: minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr;
}

.columns6 {
    grid-template-columns: minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr minmax(100px, auto) 1fr;
}

</style>